(function($) {
    $(() => {

        var lastScrollTop = 0;

        $(window).scroll(function() {
            if($(window).scrollTop() > 100) {
                $('header').addClass('is-scrolled');
            } else {
                $('header').removeClass('is-scrolled');
            }

            // DETECT SCROLL DIRECTION
            //
            var st = $(this).scrollTop();
            if (st <= lastScrollTop){
                $('.navbar').addClass('is-showed');
            } else {
                $('.navbar').removeClass('is-showed');
            }
            lastScrollTop = st;
        });

        $('.navbar-toggler').on('click', function() {
            $(this).toggleClass('is-active');
            $('.navbar-collapse').toggleClass('is-opened')
            $('.page-content, .navbar--top').toggleClass('navbar-opened')
        });

        $('.js-change-menu').click(function(){
            var target = $(this).data('target');

            $('.nav-item.active').removeClass('active');
            $(this).parents('.nav-item').addClass('active');

            if(target == 'businnes') {
                $('.navbar-collapse').removeClass('navbar-collapse--you');
                $('.navbar-collapse').addClass('navbar-collapse--businnes');
            } else {
                $('.navbar-collapse').removeClass('navbar-collapse--businnes');
                $('.navbar-collapse').addClass('navbar-collapse--you');
            }
        });

    });
})(jQuery);
